'use client';

import { Flex, HStack } from '@chakra-ui/react'
import {
	PaginationItems,
	PaginationNextTrigger,
	PaginationPageText,
	PaginationPrevTrigger,
	PaginationRoot,
} from '../../../components'

import type { PaginationRootProps } from '@chakra-ui/react'

type PaginationProps = Omit<PaginationRootProps, 'count'> & {
	total?: number | undefined
	count?: number
}

export const Pagination = ({
	count = 1,
	total,
	...props
}: PaginationProps) => {
	return (
		<PaginationRoot w='full' {...props} count={total ?? count}>
			<Flex alignItems={'center'} justify={'space-between'} w={'100%'} hideBelow={'md'}>
				<PaginationPageText flex={1} format={'long'} />
				<HStack gap={2}>
					<PaginationPrevTrigger />
					<PaginationItems />
					<PaginationNextTrigger />
				</HStack>
			</Flex>
			<HStack gap={12} hideFrom={'md'} justifyContent={'center'}>
        <PaginationPrevTrigger />
        <PaginationPageText />
        <PaginationNextTrigger />
      </HStack>
		</PaginationRoot>
	)
}
